/**
 * Manage All Routes from one file
 */

import LoginUser from "../app/auth/LoginUser";
import RegisterUser from "../app/auth/RegisterUser";
import ForgotPassword from "../app/auth/ForgotPassword";
import HomeContainer from "../app/home/home.container";
import ProfileContainer from "../app/Profile/Profile";
import Employee from "../app/Employee/Employee";
import ViewEmployeeApp from "../app/Employee/ViewEmployeeApp";
import CreateClient from "../app/Clients/CreateClient";
import Clients from "../app/Clients/Clients";
import CreateChannel from "../app/Messages/CreateChannel";
import ManageChannel from "../app/Messages/ManageChannel";
import LiveChat from "../app/Messages/LiveChat";

import {
  DashboardOutlined,
  ConfirmationNumberOutlined,
} from "@mui/icons-material";

import CreateEmployee from "../app/Employee/CreateEmployee";
import ManageGroups from "../app/Employee/ManageGroups";
import Supplies from "../app/Supplies/Cleaning/Supplies";
import SuppliesManage from "../app/Supplies/Cleaning/SuppliesManage";
import ManageSuppliesRequestDetails from "../app/Supplies/Cleaning/ManageSupplyRequestDetails/ManageSupplyRequestDetails";
import SuppliesArchiveRequestDetails from "../app/Supplies/Cleaning/SuppliesArchivesDetails";
import ArchiveSupplies from "../app/Supplies/Cleaning/SuppliesArchives";
import TimeSheetReport from "../app/CrewReport/EmployeeReports/ReportList/TimeSheet";
import ClientReport from "../app/CrewReport/ClientReports/ClientReport";
// import Shiftreport from "../app/CrewReport/ClientReports/ReportList/ShiftReport";
// import WorkSiteReport from "../app/CrewReport/ClientReports/ReportList/WorkSiteReport";
// import TaskReport from "../app/CrewReport/ClientReports/ReportList/TaskReport";
import EmployeeReport from "../app/CrewReport/EmployeeReports/EmployeeReport";
import CheckInCheckOutNew from "../app/CrewReport/EmployeeReports/ReportList/CheckInCheckOut"
import ActivityReportNew from "../app/CrewReport/EmployeeReports/ReportList/ActivityReport";
import IssueManagement from "../app/IssueManagement/IssueManagement";
import AppoinmentSchedule from "../app/Scheduler/AppoinmentSchedule";
import AccountSettings from "../app/Accounts/Settings";

import { ROLES, EMP_ROLES } from "./config";
import IssueArchive from "../app/IssueManagement/IssueArchive";
import IssueDetails from "../app/IssueManagement/IssueDetails/IssueDetails";
import Notification from "../app/Notification/Notification";
import CreateNotification from "../app/Notification/CreateNotification";
import ClientSummaryReport from "../app/Clients/ClientSummaryReport";
import ResetPassword from "../app/auth/ResetPassword";
import IssueArchiveDetails from "../app/IssueManagement/IssueDetails/IssueArchiveDetails";
import ManageAppointments from "../app/Scheduler/ManageAppointments";
// import IssuesReports from "../app/CrewReport/ClientReports/ReportList/IssuesReport";
// import SupplyReport from "../app/CrewReport/ClientReports/ReportList/SupplyReport";
import InactiveEmployee from "../app/Employee/InActiveEmployee";
import AppointmentPageSetting from "../app/Accounts/PageSettings/AppointmentSetting";
import CreateAdmin from "../app/SuperUser/Admin/CreateAdmin";
import ManageAdmin from "../app/SuperUser/Admin/ManageUserAdmin";
import CreateCompany from "../app/SuperUser/Company/CreateCompany";
import ManageCompany from "../app/SuperUser/Company/ManageCompany";
import NotificationPageSetting from "../app/Accounts/PageSettings/NotificationSetting";
import SuppliePageSetting from "../app/Accounts/PageSettings/SupplieSetting";
import IssuePageSetting from "../app/Accounts/PageSettings/IssueSetting";
import ManageSuperUser from "../app/SuperUser/ManageSuperUser";
import CreateSuperUser from "../app/SuperUser/CreateSuperUser";
import SystemAlertPage from "../app/Alerts/Systems/SystemAlertPage";
import IssuesAlertPage from "../app/Alerts/Issues/IssuesAlertPage";
import SuppliesAlertPage from "../app/Alerts/Supplies/SuppliesAlertPage";
import CompanyPageSetting from "../app/Accounts/PageSettings/CompanySetting";
import EmployeeAlertPage from "../app/Alerts/Employee/EmoloyeeAlertPage";
import ClientAlertPage from "../app/Alerts/Client/ClientAlertPage";
import AllAlertPage from "../app/Alerts/AllAlertPage";
import ManageCompanyDetails from "../app/SuperUser/Company/Details/ManageCompanyDetails";
import CompanySubscription from "../app/SuperUser/Company/CompanySubscription";
import Support from "../app/Accounts/Support";
import ContactUs from "../app/Accounts/ContactUs";
import UpgradePage from "../app/Accounts/Upgrade/Upgrade";
import ManageSupport from "../app/Accounts/ManageSupport";
import ManageSupportDetails from "../app/Accounts/ManageSupportDetails";
import ArchiveSupport from "../app/Accounts/SupportArchive";
import ArchiveSupportDetails from "../app/Accounts/SupportArchiveDetails";
import { BarChart3, HelpCircle, Users, Settings, Users2, User, Wrench, MessageSquare, FileText } from "lucide-react";
import Accounts from "../app/SuperUser/Accounts/Accounts";
import AccountDetails from "../app/SuperUser/Accounts/Details/AccountDetails";
import VerifyEmail from "../app/auth/VerifyEmail";
import VerifyEmailSent from "../components/auth/VerificationSent";
import ManageUsers from "../app/SuperUser/Users/Users";
import HelpTours from "../app/Help/Tour/HelpTour";
import UserDetails from "../app/SuperUser/Users/Details/UserDetails";
import FirebaseActionHandler from "../app/auth/FirebaseActionHandler";
import ManageChannelDetails from "../app/Messages/ManageChannelDetails";
import SuperUserDashboard from "../app/SuperUser/Dashboard/superUserDashboard";
import Analytics from "../app/SuperUser/Analytics/Analytics";
import SuperUserSettings from "../app/SuperUser/Settings/Settings";
import YourPayments from "../app/Accounts/PageSettings/YourPayments";
import InvoiceCreate from "../app/Invoices/InvoiceCreate";
import InvoiceManage from "../app/Invoices/InvoiceManage";
import ShiftVariance from "../app/CrewReport/EmployeeReports/ReportList/ShiftVarianceReport";
import MissedShift from "../app/CrewReport/EmployeeReports/ReportList/MissedShift";
import IssueResolutionLog from "../app/CrewReport/EmployeeReports/ReportList/IssueResolutionLog";
import TasksPerEmployee from "../app/CrewReport/EmployeeReports/ReportList/TaskPerEmployee";
import EscalationTracker from "../app/CrewReport/EmployeeReports/ReportList/IssueEscalation";
import ClientReportOld from "../app/CrewReport/ClientReports/OldClientReports";
import EmployeeReportOld from "../app/CrewReport/EmployeeReports/OldEmployeeReports";
import CheckInCheckOut from "../app/CrewReport/EmployeeReports/OldReportList/CheckInCheckOut";
import ActivityReport from "../app/CrewReport/EmployeeReports/OldReportList/ActivityReport";
import TimeSheet from "../app/CrewReport/EmployeeReports/OldReportList/TimeSheet";
import Shiftreport from "../app/CrewReport/ClientReports/OldReportList/ShiftReport";
import WorkSiteReport from "../app/CrewReport/ClientReports/OldReportList/WorkSiteReport";
import TaskReport from "../app/CrewReport/ClientReports/OldReportList/TaskReport";
import IssuesReports from "../app/CrewReport/ClientReports/OldReportList/IssuesReport";
import SupplyReport from "../app/CrewReport/ClientReports/OldReportList/SupplyReport";
import EmployeeSupplyRequests from "../app/CrewReport/EmployeeReports/ReportList/EmployeeSupplyRequests";
import UrgentSupplyPatterns from "../app/CrewReport/EmployeeReports/ReportList/UrgentSupplyPatterns";
import MessagesSenttoEmployee from "../app/CrewReport/EmployeeReports/ReportList/MessagesSenttoEmployee";
import EmailReportsOld from "../app/CrewReport/OldEmailReports";
import EmployeePerformanceSummary from "../app/CrewReport/EmployeeReports/ReportList/EmployeePerformanceSummary";
import UpcomingAppointments from "../app/CrewReport/ClientReports/ReportList/UpcomingAppointments";
import RescheduleAndCancelAppointment from "../app/CrewReport/ClientReports/ReportList/ReschduleAndCancel";
import MostActiveClient from "../app/CrewReport/ClientReports/ReportList/MostActiveClient";
import TaskCompletionSummary from "../app/CrewReport/ClientReports/ReportList/TaskCompletionSummary";
import VerifyNewEmail from "../app/auth/VerifyNewEmail";
import RepeatVisitsNoShows from "../app/CrewReport/ClientReports/ReportList/RepeatVisitsNoShows";
import UnReadMessage from "../app/CrewReport/EmployeeReports/ReportList/UnReadMessage";
import ClientIssueTrendsReport from "../app/CrewReport/ClientReports/ReportList/ClientIssueReport";
import RemoveCompanyUserAccount from "../app/auth/RemoveCompanyUserAccount";
import TermsOfUse, { PrivacyPolicy } from "../app/auth/TermsAndCondition";

/**
 * Array of menu items will show on left sidebar
 */
const sidebarMenuList = [
  // {
  //   label: "Create Client",
  //   to: "/peoples/createClient",
  //   classes: "button",
  //   icon: <AddBoxIcon />,
  //   roles: [ROLES.ADMIN],
  // },
  {
    label: "Home",
    to: "/dashboard",
    icon: <DashboardOutlined />,
    pkgAccess: "DASHBOARD",
    roles: [ROLES.SUPPORT, EMP_ROLES.SUPPORT , ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN],
  },
  // {
  //   label: "Profile",
  //   to: "/account/profile",
  //   pkgAccess: "PROFILE",
  //   icon: <PersonOutlinedIcon />,
  //   roles: [ROLES.SUPPORT.toLowerCase(), ROLES.EMPLOYEE.toLowerCase(), EMP_ROLES.CLIENT_TEAM.toLowerCase(), EMP_ROLES.GUEST.toLowerCase()],
  // },
  {
    label: "People",
    to: "/peoples",
    icon: <Users2 size={20}/>,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
    childItems: [
      { to: "/peoples/manageEmp", label: "Employees"},
      { to: "/peoples/manageClient", label: "Clients"},
    ],
  },
  {
    label: "Operations",
    to: "/operations",
    icon: <Wrench size={20}/>,
    roles: [ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
    childItems: [
      { to: "/operations/manageAppointments", label: "Schedule"},
      // { to: "/invoices/manage", label: "Invoices"},
      { to: "/operations/issues/manage", label: "Issues"},
      {
      label: "Supplies",
      to: "/supplies",
      roles: [ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
      childItems: [
        { to: "/supplies/cleaning/review", label: "New Request" },
        { to: "/supplies/cleaning/manage", label: "Manage" }
      ]
    }
    ],
  },
  {
    label: "Operations",
    to: "/operations",
    icon: <Wrench size={20}/>,
    roles: [ROLES.CLIENT],
    childItems: [
      { to: "/operations/manageAppointments", label: "Schedule"},
      { to: "/operations/issues/manage", label: "Issues"},
    ],
  },
  {
    label: "Supplies",
    to: "/supplies",
    icon: <Wrench size={20}/>,
    roles: [ROLES.SUPPORT.toLowerCase(), EMP_ROLES.SUPPORT],
    childItems: [
      { to: "/supplies/cleaning/review", label: "New Request"},
      { to: "/supplies/cleaning/manage", label: "Manage"},
    ],
  },
  {
    label: "Communications",
    to: "/communications",
    icon: <MessageSquare size={20} />,
    roles: [ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
    childItems: [
      { to: "/communications/message-board/live-chat", label: "Live Chat"},
      { to: "/communications/message-board/manage-channel", label: "Channels"},
      { to: "/communications/notifications/manage", label: "Notifications"},
    ],
  },
  {
    label: "Communications",
    to: "/communications",
    icon: <MessageSquare size={20} />,
    roles: [ROLES.CLIENT, ROLES.ADMIN],
    childItems: [
      { to: "/communications/message-board/live-chat", label: "Live Chat"},
    ],
  },
  {
    label: "Communications",
    to: "/communications",
    icon: <MessageSquare size={20} />,
    roles: [ROLES.SUPPORT.toLowerCase(), EMP_ROLES.SUPPORT],
    childItems: [
      { to: "/communications/notifications/manage", label: "Notifications"},
    ],
  },
  {
    label: "Reports",
    to: "/reports",
    icon: <FileText size={20} />,
    roles: [ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
    childItems: [
      { to: "/reports/Clientreport", label: "Client Reports"},
      { to: "/reports/Employeereport", label: "Team Reports"},
      {
      label: "New Reports - Beta",
      to: "/reports",
      roles: [ROLES.COMPANYUSER, , EMP_ROLES.ADMIN],
      childItems: [
        { to: "/reports/newreport/clientreport", label: "Client Reports"},
        { to: "/reports/newreport/employeereport", label: "Team Reports"},
      ]
    }
    ],
  },
  {
    label: "Reports",
    to: "/reports",
    icon: <FileText size={20} />,
    roles: [ROLES.CLIENT],
    childItems: [
      { to: "/reports/clientreport", label: "Client Reports"},
      { to: "/reports/newreport/clientreport", label: "New Client Reports"},
    ],
  },
  {
    icon: <User size={20} />,
    label: "Account",
    to: "/account",
    roles: [ROLES.COMPANYUSER],
    childItems: [
      { to: "/account/companySubscription", label: "Billing"},
      { to: "/account/userAdmin", label: "Administration"},
      { to: "/account/upgrade", label: "Plans"},
      { to: "/account/settings", label: "Settings"},
    ],
  },
  {
    icon: <User size={20} />,
    label: "Account",
    to: "/account",
    roles: [ROLES.ADMIN],
    childItems: [
      { to: "/account/userAdmin", label: "Administration"},
      { to: "/account/settings", label: "Settings"},
    ],
  },
  {
    icon: <User size={20} />,
    label: "Account",
    to: "/account",
    roles: [ROLES.SUPPORT.toLowerCase(), EMP_ROLES.SUPPORT, ROLES.EMPLOYEE.toLowerCase(), EMP_ROLES.CLIENT_TEAM.toLowerCase(), EMP_ROLES.GUEST.toLowerCase()],
    childItems: [
    { to: "/account/profile", label: "Profile", pkgAccess: "PROFILE"},
    ],
  },
  {
    icon: <HelpCircle size={20} />,
    label: "Help",
    to: "/help",
    roles: [ROLES.EMPLOYEE, ROLES.SUPPORT.toLowerCase(), EMP_ROLES.SUPPORT, EMP_ROLES.CLIENT_TEAM.toLowerCase(), EMP_ROLES.GUEST.toLowerCase()],
    childItems: [
      { to: "/help/helpTour", label: "Tour"},
      { to: "https://help.proteams.io", label: "Docs"},
    ],
  },
  {
    icon: <HelpCircle size={20} />,
    label: "Help",
    to: "/help",
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.EMPLOYEE, EMP_ROLES.ADMIN],
    childItems: [
      { to: "/help/helpTour", label: "Tour"},
      { to: "/help/manageSupport", label: "Support"},
      { to: "https://help.proteams.io", label: "Docs"},
    ],
  },
  {
    icon: <HelpCircle size={20} />,
    label: "Help",
    to: "/help",
    roles: [ROLES.CLIENT],
    childItems: [
      { to: "/help/manageSupport", label: "Support"},
      { to: "https://help.proteams.io", label: "Docs"},
    ],
  },
  // {
  //   label: "Alerts",
  //   to: "/alerts",
  //   pkgAccess: "ALERTS",
  //   icon: <ReportProblemOutlined />,
  //   roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //   childItems: [
  //     {
  //       to: "/allAlerts",
  //       pkgAccess: "ALL_ALERTS",
  //       label: "All Alerts",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //     {
  //       to: "/clientAlerts",
  //       label: "Client Alerts",
  //       pkgAccess: "CLIENT_ALERTS",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //     {
  //       to: "/empAlerts",
  //       pkgAccess: "EMP_ALERTS",
  //       label: "Employee Alerts",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //     {
  //       to: "/suppliesAlert",
  //       pkgAccess: "SUPPLIES_ALERTS",
  //       label: "Supplies Alerts",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //     {
  //       to: "/issuesAlert",
  //       pkgAccess: "ISSUES_ALERTS",
  //       label: "Issues Alerts",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //     {
  //       to: "/systemAlert",
  //       pkgAccess: "SYSTEM_ALERTS",
  //       label: "System Alerts",
  //       roles: [ROLES.SUPPORT.toLowerCase(), ROLES.ADMIN.toLowerCase(), ROLES.COMPANYUSER],
  //     },
  //   ],
  // },
  {
    label: "Dashboard",
    to: "/superUserDashboard",
    pkgAccess: "Dashboard",
    icon: <BarChart3 />,
    roles: [ROLES.SUPERUSER],
  },
  {
    label: "Support Tickets",
    to: "/help",
    pkgAccess: "SUPPORT",
    icon: <ConfirmationNumberOutlined />,
    childItems: [
      { to: "/help/manageSupport", label: "Manage", pkgAccess: "MANAGE_SUPPORT", roles: [ROLES.SUPERUSER] },
      { to: "/help/archiveSupport", label: "Archive", pkgAccess: "ARCHIVE_SUPPORT", roles: [ROLES.SUPERUSER]  },
    ],
    roles: [ROLES.SUPERUSER],
  },
    {
    label: "Accounts",
    to: "/accounts",
    pkgAccess: "Accounts",
    icon: <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>, 
    roles: [ROLES.SUPERUSER],
  },
  {
    label: "Users",
    to: "/manageUsers",
    pkgAccess: "Users",
    icon: <Users className=""/>,
    roles: [ROLES.SUPERUSER],
  },
  {
    label: "Analytics",
    to: "/analytics",
    pkgAccess: "Analytics",
    icon: <BarChart3 />,
    roles: [ROLES.SUPERUSER],
  },
  {
    label: "Settings",
    to: "/superUserSettings",
    pkgAccess: "SuperUserSettings",
    icon: <Settings />,
    roles: [ROLES.SUPERUSER],
  },
  // {
  //   label: "Account ",
  //   to: "/myAccounts",
  //   pkgAccess: "ACCOUNTS",
  //   icon: <ManageAccountsOutlined />,
  //   roles: [ROLES.ADMIN],
  //   childItems: [
  //     { to: "/userAdmin", label: "Administration", pkgAccess: "MNG_ADMIN"},
  //     { to: "/account/settings", label: "Settings", pkgAccess: "SETTINGS"},
  //   ],
  // },
  {
    label: 'User Management',
    to: "/superUser",
    icon: <User size={20} />,
    childItems: [
      { to: "/superUser", label: "Super User" },
      { to: "/company", label: "Company" },
      { to: "/account/userAdmin", label: "Company Admin" },
      { to: "/peoples/manageClient", label: "Company Client" },
      { to: "/peoples/manageEmp", label: "Company Employee" },
      { to: "/account/companySubscription", label: "Company Subscription" },
    ],
    roles: [ROLES.SUPERUSER],
  },
  // { to: "/dashboard", label: "Dashboard" },
  // {
  //   to: "",
  //   label: "Settings",
  //   heading: true,
  //   childItems: [
  //     { to: "/sidechild1", label: "SideChild1" },

  //   ],
  // },
 
];

/**
 * Routs array for authentication pages
 */
const authRoute = [
  {
    path: "/",
    component: LoginUser,
    exact: true,
    index: 1.1,
    secure: false,
    pkgAccess: "LOGIN",
    layout: "blank",
  },
  {
    path: "/login",
    component: LoginUser,
    exact: true,
    index: 1,
    pkgAccess: "LOGIN",
    layout: "blank",
    secure: false,
  },
  {
    path: "/register",
    component: RegisterUser,
    exact: true,
    index: 2,
    pkgAccess: "REGISTER",
    layout: "blank",
    secure: false,
  },
  {
    path: "/forgotpassword",
    component: ForgotPassword,
    exact: true,
    pkgAccess: "FORGOT_PASSWORD",
    index: 3,
    layout: "blank",
    secure: false,
  },
  {
    path: "/updatepassword",
    component: ResetPassword,
    exact: true,
    pkgAccess: "UPDATE_PASSWORD",
    index: 3,
    layout: "blank",
    secure: false,
  },
  {
    path: "/verify-email",
    component: VerifyEmail,
    exact: true,
    pkgAccess: "VERIFY",
    index: 4,
    secure: false,
    layout: "blank"
  },
  {
    path: "/verify-new-email",
    component: VerifyNewEmail,
    exact: true,
    pkgAccess: "VERIFY",
    index: 4,
    secure: false,
    layout: "blank"
  },
  {
    path: "/verify-email-sent",
    component: VerifyEmailSent,
    exact: true,
    pkgAccess: "VERIFY_EMAIL",
    index: 5,
    secure: false,
    layout: "blank"
  },
  {
    path: "/firebase-action-handler",
    component: FirebaseActionHandler,
    exact: true,
    pkgAccess: "FIREBASE_ACTION",
    index: 6,
    secure: false,
    layout: "blank"
  },
  {
    path: "/removeCompanyUserAccount",
    component: RemoveCompanyUserAccount,
    exact: true,
    pkgAccess: "REMOVE_ACCOUNT",
    index: 6,
    secure: false,
    layout: "blank"
  },
  {
    path: "/firebase-action-handler",
    component: FirebaseActionHandler,
    exact: true,
    pkgAccess: "FIREBASE_ACTION",
    index: 6,
    secure: false,
    layout: "blank"
  },
  {
    path: "/terms-of-use",
    component: TermsOfUse,
    exact: true,
    pkgAccess: "TERM_OF_USE",
    index: 6,
    secure: false,
    layout: "blank"
  },
  {
    path: "/privacy-policy",
    component: PrivacyPolicy,
    exact: true,
    pkgAccess: "PRIVACY_POLICY",
    index: 6,
    secure: false,
    layout: "blank"
  },
];

/***
 * routes array for secure ( if user is loggedin)
 */
const secureRoutes = [
  {
    path: "/dashboard",
    component: HomeContainer,
    exact: true,
    index: 0,
    pkgAccess: "DASHBOARD",
    secure: true,
    roles: [ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN, EMP_ROLES.SUPPORT],
  },
  {
    path: "/ViewEmployeeApp/:employeeId",
    component: ViewEmployeeApp,
    exact: true,
    index: 0,
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.ADMIN, EMP_ROLES.SUPPORT],
  },
  {
    path: "/",
    component: HomeContainer,
    exact: true,
    index: 0,
    pkgAccess: "DASHBOARD",
    secure: true,
    roles: [ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN, EMP_ROLES.SUPPORT],
  },
  {
    path: "/newDashboard",
    component: ManageAppointments,
    exact: true,
    index: 0,
    pkgAccess: "DASHBOARD",
    secure: true,
    roles: [ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN, EMP_ROLES.SUPPORT],
  },
  {
    path: "/account/profile",
    component: ProfileContainer,
    exact: true,
    index: 10,
    pkgAccess: "PROFILE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.SUPPORT.toLowerCase(), EMP_ROLES.CLIENT_TEAM.toLowerCase(), EMP_ROLES.GUEST.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN, EMP_ROLES.SUPPORT],
  },
  {
    path: "/peoples/manageEmp",
    component: Employee,
    exact: true,
    index: 11,
    pkgAccess: "MNG_EMPLOYEE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/createEmp/:employeeId",
    component: CreateEmployee,
    exact: true,
    index: 12,
    pkgAccess: "CRT_EMPLOYEE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/createEmp",
    component: CreateEmployee,
    exact: true,
    index: 12,
    pkgAccess: "CRT_EMPLOYEE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/manageGroups",
    component: ManageGroups,
    exact: true,
    index: 13,
    pkgAccess: "MNG_GROUPS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/inactiveEmp",
    component: InactiveEmployee,
    exact: true,
    index: 13,
    pkgAccess: "INACT_EMPLOYEE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/manageClient",
    component: Clients,
    exact: true,
    index: 11,
    pkgAccess: "MNG_CLIENT",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/createClient/:clientId",
    component: CreateClient,
    exact: true,
    index: 12,
    pkgAccess: "CRT_CLIENT",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/peoples/createClient",
    component: CreateClient,
    exact: true,
    index: 11,
    pkgAccess: "CRT_CLIENT",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPERUSER, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/supplies/cleaning/review",
    component: Supplies,
    exact: true,
    pkgAccess: "SUPPLIES",
    index: 13.1,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/supplies/cleaning/manage/:requestId",
    component: ManageSuppliesRequestDetails,
    exact: true,
    index: 13.21,
    pkgAccess: "MNG_SUPPLIES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/supplies/cleaning/manage",
    component: SuppliesManage,
    exact: true,
    pkgAccess: "MNG_SUPPLIES",
    index: 13.2,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/supplies/cleaning/archives",
    component: ArchiveSupplies,
    exact: true,
    index: 13.3,
    pkgAccess: "ARCH_SUPPLIES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/supplies/cleaning/archives/:requestId",
    component: SuppliesArchiveRequestDetails,
    exact: true,
    index: 13.4,
    pkgAccess: "ARCH_SUPPLIES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/supplies/cleaning",
    component: Supplies,
    exact: true,
    index: 13,
    pkgAccess: "SUPPLIES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/operations/issues/manage",
    component: IssueManagement,
    exact: true,
    index: 16,
    pkgAccess: "MNG_ISSUES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/issues/manage/:issueId",
    component: IssueDetails,
    exact: true,
    pkgAccess: "MNG_ISSUES",
    index: 16.1,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/issues/archive",
    component: IssueArchive,
    exact: true,
    pkgAccess: "ARCH_ISSUES",
    index: 16,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/issues/archive/:issueId",
    component: IssueArchiveDetails,
    exact: true,
    pkgAccess: "ARCH_ISSUES",
    index: 16,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/notifications/manage",
    component: Notification,
    exact: true,
    index: 17,
    pkgAccess: "MNG_NOTIFICATION",
    secure: true,
    roles: [ EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.SUPPORT],
  },
  {
    path: "/communications/notifications/create",
    component: CreateNotification,
    exact: true,
    index: 17,
    pkgAccess: "CRT_NOTIFICATION",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.SUPPORT],
  },
  {
    path: "/allAlerts",
    component: AllAlertPage,
    exact: true,
    index: 18,
    pkgAccess: "ALL_ALERTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/empAlerts",
    component: EmployeeAlertPage,
    exact: true,
    index: 18,
    pkgAccess: "EMP_ALERTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  }, {
    path: "/clientAlerts",
    component: ClientAlertPage,
    exact: true,
    index: 18,
    pkgAccess: "CLIENT_ALERTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  }, {
    path: "/suppliesAlert",
    component: SuppliesAlertPage,
    exact: true,
    index: 18,
    pkgAccess: "SUPPLIES_ALERTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  }, {
    path: "/issuesAlert",
    component: IssuesAlertPage,
    exact: true,
    pkgAccess: "ISSUES_ALERTS",
    index: 18,
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  }, {
    path: "/systemAlert",
    component: SystemAlertPage,
    exact: true,
    index: 18,
    pkgAccess: "SYSTEM_ALERTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.SUPPORT.toLowerCase(), ROLES.COMPANYUSER, EMP_ROLES.SUPPORT],
  },
  {
    path: "/admin/clientSummary",
    component: ClientSummaryReport,
    exact: true,
    pkgAccess: "CLIENT_SUMMARY",
    index: 19,
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, EMP_ROLES.ADMIN],
  },
  {
    path: "/reports/newreport/clientreport",
    component: ClientReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_CLIENTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT, EMP_ROLES.ADMIN],
  },
  {
    path: "/reports/newreport/upcomingAppointments",
    component: UpcomingAppointments,
    exact: true,
    index: 20,
    pkgAccess: "REPT_UPCOMINGAPPT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/newreport/cancelAndReschduleAppointment",
    component: RescheduleAndCancelAppointment,
    exact: true,
    index: 20,
    pkgAccess: "REPT_CANCELAPPT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/newreport/repeatVisitsNoShows",
    component: RepeatVisitsNoShows,
    exact: true,
    index: 20,
    pkgAccess: "REPT_REPTVISINOSHOW",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/newreport/mostActiveClient",
    component: MostActiveClient,
    exact: true,
    index: 20,
    pkgAccess: "REPT_MSTACTCLIENT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/newreport/taskCompletionSummary",
    component: TaskCompletionSummary,
    exact: true,
    index: 20,
    pkgAccess: "REPT_TASKSUMMARY",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/ShiftReport",
    component: Shiftreport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_SHIFT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/Worksitereport",
    component: WorkSiteReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_WORKSITE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/Taskreport",
    component: TaskReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_TASK",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/Issuesreport",
    component: IssuesReports,
    exact: true,
    index: 20,
    pkgAccess: "REPT_ISSUES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/Supplyreport",
    component: SupplyReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_SUPPLIES",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/newreport/clientIssueTrends",
    component: ClientIssueTrendsReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_CLIENTISSUE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/reports/Employeereport",
    component: EmployeeReportOld,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMPLOYEE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/Clientreport",
    component: ClientReportOld,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMPLOYEE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/employeereport",
    component: EmployeeReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMPLOYEE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/Checkincheckout",
    component: CheckInCheckOut,
    exact: true,
    index: 20,
    pkgAccess: "REPT_CHECKINOUT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/Activityreports",
    component: ActivityReport,
    exact: true,
    index: 20,
    pkgAccess: "REPT_AACTIVITY",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/Timesheet",
    component: TimeSheet,
    exact: true,
    index: 20,
    pkgAccess: "REPT_TIMESHEET",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/checkInCheckOut",
    component: CheckInCheckOutNew,
    exact: true,
    index: 20,
    pkgAccess: "REPT_CHECKINOUT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/unReadMessage",
    component: UnReadMessage,
    exact: true,
    index: 20,
    pkgAccess: "REPT_UNREADMESSAGE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/shiftVariance",
    component: ShiftVariance,
    exact: true,
    index: 20,
    pkgAccess: "REPT_SHIFTVARIANCE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/missedShift",
    component: MissedShift,
    exact: true,
    index: 20,
    pkgAccess: "REPT_MISSEDSHIFT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/issueResolutionLog",
    component: IssueResolutionLog,
    exact: true,
    index: 20,
    pkgAccess: "REPT_ISSUESRESOLUTIONLOG",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/escalationTracker",
    component: EscalationTracker,
    exact: true,
    index: 20,
    pkgAccess: "REPT_ESCALATIONTRACKER",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/empSupplyRequest",
    component: EmployeeSupplyRequests,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMPSUPPLYREQUEST",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/urgentSupplyPatterns",
    component: UrgentSupplyPatterns,
    exact: true,
    index: 20,
    pkgAccess: "REPT_URGENTSUPPLYPATTERNS",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/messagesEndToEmployee",
    component: MessagesSenttoEmployee,
    exact: true,
    index: 20,
    pkgAccess: "REPT_MESSAGESENTTOEMPLOYEE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/tasksPerEmployee",
    component: TasksPerEmployee,
    exact: true,
    index: 20,
    pkgAccess: "REPT_TASKSPEREMPLOYEE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/activityReports",
    component: ActivityReportNew,
    exact: true,
    index: 20,
    pkgAccess: "REPT_ACTIVITY",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/reports/newreport/employeeOverAllPerformance",
    component: EmployeePerformanceSummary,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMPOVERALLPERFROMANCE",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/emailreports",
    component: EmailReportsOld,
    exact: true,
    index: 20,
    pkgAccess: "REPT_EMAILS",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/message-board/create-channel",
    component: CreateChannel,
    exact: true,
    index: 20,
    pkgAccess: "CRT_CHANNELS",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/message-board/create-channel/:channelId",
    component: CreateChannel,
    exact: true,
    pkgAccess: "CRT_CHANNELS",
    index: 20,
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/message-board/manage-channel",
    component: ManageChannel,
    exact: true,
    index: 20,
    pkgAccess: "MNG_CHANNELS",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/message-board/manage-channel/:channelId",
    component: ManageChannelDetails,
    exact: true,
    index: 20,
    pkgAccess: "MNG_CHANNELS",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/communications/message-board/live-chat",
    component: LiveChat,
    exact: true,
    index: 20,
    pkgAccess: "LIVE_CHAT",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/appoinmentSchedule",
    component: AppoinmentSchedule,
    exact: true,
    index: 21,
    pkgAccess: "CRT_APPT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/appoinmentSchedule/:appointmentId",
    component: AppoinmentSchedule,
    exact: true,
    index: 21,
    pkgAccess: "CRT_APPT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/operations/manageAppointments",
    component: ManageAppointments,
    exact: true,
    index: 21,
    pkgAccess: "MNG_APPT",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.CLIENT],
  },
  {
    path: "/invoices/create",
    component: InvoiceCreate,
    exact: true,
    index: 21,
    pkgAccess: "CRT_INV",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/invoices/manage",
    component: InvoiceManage,
    exact: true,
    index: 21,
    pkgAccess: "MNG_INV",
    secure: true,
    roles: [EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings",
    component: AccountSettings,
    exact: true,
    index: 22,
    pkgAccess: "SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/upgrade",
    component: UpgradePage,
    exact: true,
    index: 22,
    pkgAccess: "UPGRADE",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/help/support",
    component: Support,
    exact: true,
    index: 22,
    pkgAccess: "CREATE_SUPPORT",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/contactUs",
    component: ContactUs,
    exact: true,
    index: 22,
    pkgAccess: "CONTACTUS",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/manageSupportDetails/:supportID",
    component: ManageSupportDetails,
    exact: true,
    index: 22,
    pkgAccess: "DETAILS_SUPPORT",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.SUPERUSER, ROLES.CLIENT],
  },
  {
    path: "/help/manageSupportDetails/:supportID",
    component: ManageSupportDetails,
    exact: true,
    index: 22,
    pkgAccess: "DETAILS_SUPPORT",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.SUPERUSER, ROLES.CLIENT],
  },
  {
    path: "/help/manageSupport",
    component: ManageSupport,
    exact: true,
    index: 22,
    pkgAccess: "MANAGE_SUPPORT",
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.COMPANYUSER, ROLES.SUPERUSER, ROLES.CLIENT],
  },
  {
    path: "/help/archiveSupportDetails/:supportID",
    component: ArchiveSupportDetails,
    exact: true,
    index: 22,
    pkgAccess: "ARCHIVEDETAILS_SUPPORT",
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/help/archiveSupport",
    component: ArchiveSupport,
    exact: true,
    index: 22,
    pkgAccess: "ARCHIVE_SUPPORT",
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/account/settings/appointmentPageSetting",
    component: AppointmentPageSetting,
    exact: true,
    index: 22,
    pkgAccess: "APPT_SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings/notificationPageSetting",
    component: NotificationPageSetting,
    exact: true,
    index: 22,
    pkgAccess: "NOTIFICATION_SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings/suppliePageSetting",
    component: SuppliePageSetting,
    exact: true,
    index: 22,
    pkgAccess: "SUPPLY_SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings/issuePageSetting",
    component: IssuePageSetting,
    exact: true,
    index: 22,
    pkgAccess: "ISSUES_SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings/payments",
    component: YourPayments,
    exact: true,
    index: 22,
    pkgAccess: "YOUR_PAYMENTS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/account/settings/companyPageSetting",
    component: CompanyPageSetting,
    exact: true,
    index: 22,
    pkgAccess: "CLIENTS_SETTINGS",
    secure: true,
    roles: [ROLES.ADMIN, ROLES.COMPANYUSER],
  },
  {
    path: "/createSuperUser",
    component: CreateSuperUser,
    exact: true,
    index: 23,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/createSuperUser/:superUserId",
    component: CreateSuperUser,
    exact: true,
    index: 23,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/superUser",
    component: ManageSuperUser,
    exact: true,
    index: 23,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/createCompany",
    component: CreateCompany,
    exact: true,
    index: 24,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/createCompany/:companyId",
    component: CreateCompany,
    exact: true,
    index: 24,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/company",
    component: ManageCompany,
    exact: true,
    index: 24,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/companyDetails/:companyId",
    component: ManageCompanyDetails,
    exact: true,
    index: 24,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/account/companySubscription",
    component: CompanySubscription,
    exact: true,
    index: 24,
    pkgAccess: "COMPNAY_SUBSCRIPTION",
    secure: true,
    roles: [ROLES.SUPERUSER, ROLES.COMPANYUSER, ROLES.ADMIN],
  },
  {
    path: "/account/createUserAdmin",
    component: CreateAdmin,
    exact: true,
    index: 25,
    pkgAccess: "CRT_ADMIN",
    secure: true,
    roles: [ROLES.SUPERUSER, ROLES.COMPANYUSER, ROLES.ADMIN],
  },
  {
    path: "/account/createUserAdmin/:adminId",
    component: CreateAdmin,
    exact: true,
    index: 25,
    pkgAccess: "CRT_ADMIN",
    secure: true,
    roles: [ROLES.SUPERUSER, ROLES.COMPANYUSER, ROLES.ADMIN],
  },
  {
    path: "/account/userAdmin",
    component: ManageAdmin,
    exact: true,
    pkgAccess: "MNG_ADMIN",
    index: 25,
    secure: true,
    roles: [ROLES.SUPERUSER, ROLES.COMPANYUSER, ROLES.ADMIN],
  },
  {
    path: "/accounts",
    component: Accounts,
    exact: true,
    pkgAccess: "ACCOUNTS",
    index: 26,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/accountsDetails/:accountId",
    component: AccountDetails,
    exact: true,
    pkgAccess: "ACCOUNTS_DETAILS",
    index: 26,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/manageUsers",
    component: ManageUsers,
    exact: true,
    pkgAccess: "MANAGE_USERS",
    index: 27,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/manageUsersDetails/:userId",
    component: UserDetails,
    exact: true,
    pkgAccess: "USERS_DETAILS",
    index: 27,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/help/helpTour",
    component: HelpTours,
    exact: true,
    pkgAccess: "TOUR",
    index: 28,
    secure: true,
    roles: [ROLES.ADMIN, EMP_ROLES.ADMIN, ROLES.EMPLOYEE, ROLES.SUPPORT.toLowerCase(), EMP_ROLES.SUPPORT, EMP_ROLES.CLIENT_TEAM.toLowerCase(), EMP_ROLES.GUEST.toLowerCase(), ROLES.COMPANYUSER, ROLES.CLIENT],
  },
    {
    path: "/superUserDashboard",
    component: SuperUserDashboard,
    exact: true,
    pkgAccess: "SUPERUSER_DASHBOARD",
    index: 29,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/analytics",
    component: Analytics,
    exact: true,
    pkgAccess: "Analytics",
    index: 29,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
  {
    path: "/superUserSettings",
    component: SuperUserSettings,
    exact: true,
    pkgAccess: "SuperUserSettings",
    index: 29,
    secure: true,
    roles: [ROLES.SUPERUSER],
  },
];
const routes = [...authRoute, ...secureRoutes];

export { sidebarMenuList, routes, secureRoutes };
